import { ModuleType } from "../../../../templates/types";
import type { LearnAboutInfo } from "../LearnScreen";
import { CalendarLearnMore } from "./calendarLearnMoreData";
import { CheckboxLearnMore } from "./checkboxLearnMoreData";
import { DateDueLearnMore } from "./dateDueLearnMoreData";
import { ExpenseLearnMore } from "./expenseLearnMoreData";
import { InfoLearnMore } from "./infoLearnMoreData";
import { LocationLearnMore } from "./locationLearnMoreData";
import { PollLearnMore } from "./pollLearnMoreData";

export const learnMoreData: Record<ModuleType, LearnAboutInfo[]> = {
  [ModuleType.PlanInfo]: [],

  [ModuleType.Calendar]: CalendarLearnMore,
  [ModuleType.Location]: LocationLearnMore,
  [ModuleType.Expense]: ExpenseLearnMore,
  [ModuleType.DateDue]: DateDueLearnMore,
  [ModuleType.Reminder]: DateDueLearnMore,
  [ModuleType.Checkboxes]: CheckboxLearnMore,
  [ModuleType.Poll]: PollLearnMore,
  [ModuleType.Info]: InfoLearnMore,

  // TODO - missing images
  [ModuleType.Tracker]: [], // TrackerLearnMore,
  [ModuleType.Rsvp]: [],
};

export const hasHelpData = (type: ModuleType) => {
  return learnMoreData[type] && learnMoreData[type].length > 0;
};
